import {StyleSheet} from 'react-native';

import {CARD_HEIGHT} from '../config';

export const styles = StyleSheet.create({
  base: {
    minHeight: CARD_HEIGHT,
    minWidth: 250,
  },
  cardHeaderText: {
    marginBottom: 12,
  },
  listItem: {
    paddingVertical: 0,
    marginBottom: 10,
  },
  listItemLast: {
    marginBottom: 0,
  },
});
